import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb8bc3d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "back-icon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "Checkout", -1))
const _hoisted_4 = { class: "amount" }
const _hoisted_5 = { class: "currency" }
const _hoisted_6 = { class: "checkout-container" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

import { ref } from "vue";
import { Radio, RadioGroup, Row, Col, Icon } from "vant";
import { usePayList, usePayTypes, init, submitHandler } from "../model";

// 展开关闭的列表

export default /*#__PURE__*/_defineComponent({
  __name: 'checkoutMove',
  setup(__props) {

const { activeNames, changeOpen } = usePayList()
// 单选框的值
const checkContent = ref<string>("")
// 数据请求初始化
const { order: orderObj, payTypes } = usePayTypes()
init(orderObj, payTypes)

// 按钮步骤
const loading = ref(false)
function submit() {
  submitHandler(checkContent.value, checkContent.value, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_CHLoading = _resolveComponent("CHLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Icon), {
          name: "arrow-left",
          class: "arrow"
        })
      ]),
      _hoisted_3
    ]),
    _createVNode(_unref(Row), {
      class: "amount-container",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(orderObj).amount), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(orderObj).currencyCode), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(RadioGroup), {
        modelValue: checkContent.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkContent).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payTypes), (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_unref(Row), {
                style: {"cursor":"pointer"},
                class: "row parent",
                align: "center",
                justify: "space-between",
                onClick: ($event: any) => (item.childrenList.length ? _unref(changeOpen)(index) : null)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Row), { align: "center" }, {
                    default: _withCtx(() => [
                      (item.url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.url,
                            style: {"width":"28px","margin-right":"6px"}
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, _toDisplayString(item.mode), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(Col), null, {
                    default: _withCtx(() => [
                      (item.childrenList.length)
                        ? (_openBlock(), _createBlock(_unref(Icon), {
                            key: 0,
                            name: _unref(activeNames).includes(index) ? 'arrow-down' : 'arrow-left'
                          }, null, 8, ["name"]))
                        : (_openBlock(), _createBlock(_unref(Radio), {
                            key: 1,
                            name: item.value
                          }, null, 8, ["name"]))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (item.childrenList.length && _unref(activeNames).includes(index))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.childrenList, (childItem, index) => {
                    return (_openBlock(), _createElementBlock("section", {
                      key: index + 'main'
                    }, [
                      _createVNode(_unref(Row), {
                        class: "row child",
                        align: "center",
                        justify: "space-between"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Row), null, {
                            default: _withCtx(() => [
                              (childItem.url)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: childItem.url,
                                    style: {"width":"28px","margin-right":"6px"}
                                  }, null, 8, _hoisted_8))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, _toDisplayString(childItem.mode), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(Radio), {
                            name: childItem.value
                          }, null, 8, ["name"])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_unref(Row), {
      class: "btn-group",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "btn",
          onClick: submit
        }, "PAY")
      ]),
      _: 1
    }),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_CHLoading, {
          key: 0,
          text: "Processing"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})